import React from "react";
import { Box } from "@mui/material";
import Text from "./text/Text";

function ErrorMessageContent({ img, msg, subMsg, padding }) {
  return (
    <Box
      className="error-msg-wrapper"
      sx={{
        padding: padding ? "" : "20px",
      }}
    >
      <img src={img} height="54px" width="54px" />
      <Text className="default-text" size={22} font="bold">
        {msg}
      </Text>
      <Text className="grey-text" size={16} font="regular">
        {subMsg}
      </Text>
    </Box>
  );
}

export default ErrorMessageContent;
